/**
 * Query parameters for extraction preview list
 * HU28-922486: Listado de muestras de extracción
 */
export interface ExtractionPreviewQueryParams {
  readonly page?: number;
  readonly size?: number;
  readonly sortBy?: string;
  readonly sortDirection?: 'ASC' | 'DESC';
}

/**
 * Default query parameters
 */
export const DEFAULT_EXTRACTION_PREVIEW_QUERY: ExtractionPreviewQueryParams = {
  page: 0,
  size: 10,
  sortBy: 'extractionDate',
  sortDirection: 'ASC'
};
